import React from "react";
import { Link } from "react-router-dom";

// Shown for any URL that matches no route, instead of a blank page (ML-41).
const NotFound = () => (
  <div className="d-flex flex-column align-items-center justify-content-center text-center p-4" style={{ minHeight: "60vh" }}>
    <h4 className="mb-2">Page not found</h4>
    <p className="text-muted mb-4">The address may be mistyped, or the page has moved.</p>
    <Link to="/dashboard" className="btn btn-primary">
      Go to Dashboard
    </Link>
  </div>
);

export default NotFound;
